import {combineReducers} from "redux";

// TODO: to delete
export function error(state = null, action) {
    switch (action.type) {
        case "NOTIFICATION_LIST_ERROR":
            return action.error;

        default:
            return state;
    }
}

// TODO: to delete
export function loading(state = false, action) {
    switch (action.type) {
        case "NOTIFICATION_LIST_LOADING":
            return action.loading;

        default:
            return state;
    }
}

// do not delete
export function notification(state = false, action) {
    switch (action.type) {
        case "ADD_NEW_NOTIFICATION":
            return action.notification;

        default:
            return state;
    }
}

// TODO: to delete
export function retrieved(state = false, action) {
    switch (action.type) {
        case "NOTIFICATION_LIST_SUCCESS":
            return action.retrieved;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved, notification});
